import { render, staticRenderFns } from "./MedicalRecordItem.vue?vue&type=template&id=6dc4c053&scoped=true&"
import script from "./MedicalRecordItem.vue?vue&type=script&lang=js&"
export * from "./MedicalRecordItem.vue?vue&type=script&lang=js&"
import style0 from "./MedicalRecordItem.vue?vue&type=style&index=0&id=6dc4c053&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dc4c053",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
